import { render, staticRenderFns } from "./CourseModule.vue?vue&type=template&id=e86af2e2&scoped=true&"
import script from "./CourseModule.vue?vue&type=script&lang=js&"
export * from "./CourseModule.vue?vue&type=script&lang=js&"
import style0 from "./CourseModule.vue?vue&type=style&index=0&id=e86af2e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86af2e2",
  null
  
)

export default component.exports